import {useEffect, useState} from "react";

export default function AlphaAvatar({name, size = 40, className = ''}: {
    name: string,
    size?: number,
    className?: string
}) {
    const [avatar, setAvatar] = useState<string | undefined>(undefined)
    useEffect(() => {
        if (name) {
            const char = name[0].toUpperCase()
            // if (char.match(/[a-zA-Z]/)) {
                setAvatar(char)
            // }
        }
    }, [name])
    return <div className={`matchid-alpha-avatar ${className}`} style={{
        width: size,
        height: size,
        fontSize: Math.ceil(size / 2)
    }}>
        {avatar}
    </div>
}